<template>
  <div id="app">
    <!-- 全局导航栏 -->
    <Nav v-if="!isAdminPage" />
    <!-- 页面内容 -->
    <main class="main-content">
      <router-view/>
    </main>
    <!-- 全局页脚，后台管理页面不显示 -->
    <Footer class="footer" v-if="!isAdminPage">
    </Footer>
  </div>
</template>

<script>
import Nav from './components/Nav.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Nav,
    Footer
  },
  computed: {
    isAdminPage() {
      // 获取当前路由路径
      const currentPath = this.$route.path
      // 后台管理页面包括登录页和后台主页
      return ['/login', '/admin', '/xueliang-login'].includes(currentPath)
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* 主要内容区域，避免被固定导航栏遮挡 */
.main-content {
  /* padding-top: 80px;  */
}

/* 基础样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 通用按钮样式 */
.btn {
  display: inline-block;
  padding: 10px 20px;
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s ease;
}

.btn:hover {
  background: #40a9ff;
}

/* 通用标题样式 */
.section-title {
  font-size: 32px;
  text-align: center;
  margin-bottom: 40px;
  color: #333;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .section-title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .btn {
    padding: 8px 16px;
    font-size: 14px;
  }
}
</style>
